import axios from "axios";

import { getConstansApiRoute } from "../apiRoutes";

export function getServerConstants() {
  return axios
    .get(getConstansApiRoute)
    .then(res => res)
    .catch(err => err.response);
}
